// extracted by mini-css-extract-plugin
export var actionButton = "_nf-0";
export var actionMenuContainer = "_nf-i";
export var bubble = "_nf-2";
export var bubbleActionMenu = "_nf-j";
export var bubbleContext = "_nf-6";
export var bubbleItems = "_nf-7";
export var customer = "_nf-3";
export var divider = "_nf-8";
export var fileList = "_nf-9";
export var hiddenComment = "_nf-o";
export var infoAbove = "_nf-a";
export var internal = "_nf-4";
export var lightActionButton = "_nf-1";
export var link = "_nf-b";
export var merchant = "_nf-5";
export var message = "_nf-c";
export var profilePicture = "_nf-e";
export var quillToolbarContainer = "_nf-f";
export var senderDate = "_nf-g";
export var senderDateCustomer = "_nf-h";
export var senderName = "_nf-d";
export var time = "_nf-k";
export var uploadedImage = "_nf-l";
export var username = "_nf-m";
export var xsmall = "_nf-n";